/* ========== COMBO CHART (mixed bar/column + line) ========== */

import {
  COLORS,
  drawAxes,
  drawGridlines,
  drawCategoryLabels,
  getMinMaxRange,
} from './utils';

export function drawComboChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var barSeries = seriesArr.filter(function (s) { return s.renderType === 'bar' || s.renderType === 'col'; });
  var lineSeries = seriesArr.filter(function (s) { return s.renderType !== 'bar' && s.renderType !== 'col'; });
  var numCategories = Math.max.apply(null, seriesArr.map(function (s) { return s.data.length; }).concat([1]));

  var mmr = getMinMaxRange(seriesArr);
  var groupWidth = width / numCategories;

  drawGridlines(ctx, x, y, width, height, mmr.minValue, mmr.range);

  if (barSeries.length > 0) {
    var numBarSeries = barSeries.length;
    var barWidth = (groupWidth * 0.8) / numBarSeries;
    var groupPad = groupWidth * 0.1;

    barSeries.forEach(function (series, sIdx) {
      var globalIdx = seriesArr.indexOf(series);
      series.data.forEach(function (value, cIdx) {
        var barHeight = ((value - mmr.minValue) / mmr.range) * height;
        var barX = x + cIdx * groupWidth + groupPad + sIdx * barWidth;
        var barY = y + height - barHeight;
        ctx.fillStyle = series.color || COLORS[globalIdx % COLORS.length];
        ctx.fillRect(barX, barY, barWidth, barHeight);
      });
    });
  }

  lineSeries.forEach(function (series) {
    var globalIdx = seriesArr.indexOf(series);
    var data = series.data;
    if (!data || data.length === 0) return;
    var color = series.color || COLORS[globalIdx % COLORS.length];
    var pointSpacing = groupWidth;

    ctx.strokeStyle = color;
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    data.forEach(function (value, index) {
      var px = x + index * pointSpacing + pointSpacing / 2;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.stroke();

    data.forEach(function (value, index) {
      var px = x + index * pointSpacing + pointSpacing / 2;
      var py = y + height - ((value - mmr.minValue) / mmr.range) * height;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, 3.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
  });

  var band = drawCategoryLabels(ctx, x, y, height, chartObj.categories || [], numCategories, groupWidth, chartObj.catLevels);
  drawAxes(ctx, x, y, width, height);

  // Mixed legend: lines as line, bars as filled rect
  ctx.font = '9px Calibri, Arial';
  ctx.textBaseline = 'middle';
  var totalLegendW = 0;
  seriesArr.forEach(function (s) { totalLegendW += 14 + ctx.measureText(s.name).width + 16; });
  var legendX = x + (width - totalLegendW) / 2;
  var legendY = y + height + (band || 15) + 7;
  seriesArr.forEach(function (s, i) {
    var color = s.color || COLORS[i % COLORS.length];
    var isLine = s.renderType !== 'bar' && s.renderType !== 'col';
    if (isLine) {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(legendX, legendY);
      ctx.lineTo(legendX + 10, legendY);
      ctx.stroke();
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(legendX + 5, legendY, 2.5, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.fillStyle = color;
      ctx.fillRect(legendX, legendY - 5, 10, 10);
    }
    ctx.fillStyle = '#333';
    ctx.textAlign = 'left';
    ctx.fillText(s.name, legendX + 14, legendY);
    legendX += 14 + ctx.measureText(s.name).width + 16;
  });
}
